
<header @click="$emit('click')">
  <h1 v-if="title" :class="{ small }" class="secondary-font">
    {{ title }}
  </h1>

  <div v-if="$slots['title']" class="title">
    <slot name="title" />
  </div>

  <div class="actions">
    <slot name="actions" />
  </div>
</header>
